import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { makeHeaderRow } from '../../utils/goal_statics';
import TaxbillStaticsTeamTable from '../../components/taxbill_statics/TaxbillStaticsTeamTable';
import * as staticsApi from '../../lib/api/statics';

const TaxbillStaticsTeamContainer = ({
  selectedYear,
  strMonth,
  endMonth,
  tableRef,
  searchDate,
  selectedGbn,
  selectPrjTyp,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [headerRows, setHeaderRows] = useState(null);

  // const onLoadData = () => {
  //   setLoading(true);
  //   const loadedHeaders = makeHeaderRow(strMonth, endMonth);
  //   const loadedData = makeGoalStaticsTeamData(loadedHeaders);
  //   setHeaderRows(loadedHeaders);
  //   setData(loadedData);
  //   setLoading(false);
  //   console.log(JSON.stringify(loadedData), 'emp');
  // };

  const onLoadData = async () => {
    setLoading(true);

    try {
      const loadedHeaders = makeHeaderRow(strMonth, endMonth);
      setHeaderRows(loadedHeaders);
      const res = await staticsApi.getTeamTaxbillStatics(
        selectedYear,
        strMonth,
        endMonth,
        selectedGbn,
        selectPrjTyp,
      );
      if (res.data.list) {
        setData(res.data.list);
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    if (searchDate) {
      onLoadData();
    }
  }, [searchDate]);
  return (
    <TaxbillStaticsTeamTable
      data={data}
      loading={loading}
      selectedGbn={selectedGbn}
      headerRows={headerRows}
      tableRef={tableRef}
    />
  );
};

export default TaxbillStaticsTeamContainer;
